update_breaks();
update_breaks_price();
setTimeout(function() {
  update__price();
}, 2000);

$(document).on("click","#quantity1, #quantity2, #quantity3, #quantity4",function() {
  $('.breaks-inputs').removeClass('active');
  $(this).prev("input[type='radio']").prop("checked", true);
  $(this).next().find('.breaks-inputs').addClass('active');
  update_breaks();
  update_breaks_price()
});

$(document).on("change",".quantity-break__variant-select",function() {
  var id = $(this).val()
  var index = $(this).parents('.quantity-break__selector-item').data('select-index')

  $(this).parents('.quantity-break').find('.breaks-inputs input[data-select-index="'+index+'"]').val(id);
  update_breaks();
  update_breaks_price()
});
  
function update_breaks() {
  var inputs_Html = $('.breaks-inputs.active').html();
  
  $('.product-form__variants').html('');
  $('.product-form__variants').html(inputs_Html);
}

function update_breaks_price() {
  if($('.quantity-breaks-container [name="quantity"]:checked').length > 0){ 
  $('.lumin-price').addClass('price--on-sale');
  $('.price__container').addClass('price--on-sale');
    
  var qty = $('.quantity-breaks-container [name="quantity"]:checked').val();
  var price = $('.quantity-breaks-container [name="quantity"]:checked').next().find('[data-text="[price]"]').text().trim();
  var compare = $('.quantity-breaks-container [name="quantity"]:checked').next().find('[data-text="[compare_price]"]').text().trim();

  $('.price-item--sale').text(price);
  $('.price-item--regular').text(compare);
  }
}

function update__price() {
  if($('.product-info').length > 0){
  var price = $('.product-info .price-item--sale').text().trim();
  var compare = $('.product__info-container .price--on-sale .price__sale .price-item--regular').text().trim();

  $('.price-item--sale').text(price);
  $('.price-item--regular').text(compare);
  }
}